import React from "react";
import { Link } from "react-router-dom";

interface WithdrawalStatsProps {
    data: {
        last24h: {
            total: number;
            count: number;
            total_hub: number;
            total_game: number;
        };
        last7d: {
            total: number;
            count: number;
            total_hub: number;
            total_game: number;
        };
        last30d: {
            total: number;
            count: number;
            total_hub: number;
            total_game: number;
        };
    };
}

export const WithdrawalStats: React.FC<WithdrawalStatsProps> = ({ data }) => {
    const formatAmount = (amount: number): string => {
        return new Intl.NumberFormat("ru-RU", {
            style: "currency",
            currency: "USD",
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        }).format(amount);
    };

    return (
        <div className="bg-white dark:bg-gray-800 shadow rounded-lg p-4">
            <h2 className="text-xl font-semibold mb-2 text-gray-900 dark:text-white">
                Выводы{" "}
                <small>
                    (
                    <Link
                        to="/dashboard/admin/withdrawals"
                        className="text-blue-500 underline hover:text-blue-600"
                    >
                        Посмотреть все выводы
                    </Link>
                    )
                </small>
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                <div className="p-4 rounded-md border border-gray-200 dark:border-gray-700">
                    <div className="text-sm text-gray-500 dark:text-gray-400">
                        За 24 часа
                    </div>
                    <div className="text-2xl font-bold text-gray-900 dark:text-white">
                        {formatAmount(data.last24h.total)}
                    </div>
                    <div className="text-sm text-red-600 dark:text-red-400">
                        Транзакций: {data.last24h.count}
                    </div>
                    <div className="text-sm text-red-600 dark:text-red-400">
                        Хаб: {formatAmount(data.last24h.total_hub)}
                    </div>
                    <div className="text-sm text-red-600 dark:text-red-400">
                        Игра: {formatAmount(data.last24h.total_game)}
                    </div>
                </div>
                <div className="p-4 rounded-md border border-gray-200 dark:border-gray-700">
                    <div className="text-sm text-gray-500 dark:text-gray-400">
                        За 7 дней
                    </div>
                    <div className="text-2xl font-bold text-gray-900 dark:text-white">
                        {formatAmount(data.last7d.total)}
                    </div>
                    <div className="text-sm text-red-600 dark:text-red-400">
                        Транзакций: {data.last7d.count}
                    </div>
                    <div className="text-sm text-red-600 dark:text-red-400">
                        Хаб: {formatAmount(data.last7d.total_hub)}
                    </div>
                    <div className="text-sm text-red-600 dark:text-red-400">
                        Игра: {formatAmount(data.last7d.total_game)}
                    </div>
                </div>
                <div className="p-4 rounded-md border border-gray-200 dark:border-gray-700">
                    <div className="text-sm text-gray-500 dark:text-gray-400">
                        За 30 дней
                    </div>
                    <div className="text-2xl font-bold text-gray-900 dark:text-white">
                        {formatAmount(data.last30d.total)}
                    </div>
                    <div className="text-sm text-red-600 dark:text-red-400">
                        Транзакций: {data.last30d.count}
                    </div>
                    <div className="text-sm text-red-600 dark:text-red-400">
                        Хаб: {formatAmount(data.last30d.total_hub)}
                    </div>
                    <div className="text-sm text-red-600 dark:text-red-400">
                        Игра: {formatAmount(data.last30d.total_game)}
                    </div>
                </div>
            </div>
        </div>
    );
};
